import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
  {
    // 大众安徽常见问题
    path: '/allProblemsAVW/:id?',
    name: 'allProblemsAVW',
    component: () =>
      import(/* webpackChunkName: "allProblemsVW" */ '@/views/avw/help-center/AllQuestion.vue'),
    meta: {
      cname: '全部问题'
    }
  },
  {
    // 大众安徽常见问题
    path: '/commonProblemsAVW',
    name: 'commonProblemsAVW',
    component: () =>
      import(/* webpackChunkName: "CustomerServiceAVW" */ '@/views/avw/help-center/IndexView.vue')
  },
  {
    // 大众安徽问题详情
    path: '/commonProblemsAVW/detail',
    name: 'commonProblemsDetailDAVW',
    component: () =>
      import(
        /* webpackChunkName: "commonProblemsDetailDAVW" */ '@/views/avw/help-center/QuestionDetail.vue'
      ),
    meta: {
      cname: '问题详情'
    }
  },
  {
    path: '/intelligent-unlockingAVW',
    name: 'intelligentUnlockingWithAppAVW',
    component: () =>
      import(/* webpackChunkName: "SmartLockerManualVW" */ '@/views/avw/SmartLockerManual.vue'),
    meta: {
      cname: '智能解闭锁'
    },
    props: true
  }
];
export default routes;
